import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Typography } from '@mui/material';
import { clientGrey } from '../../theme/style';

const RichTextEditor = ({ value, onChange, label, error, placeholder }) => {
  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ];

  const handleChange = (content) => {
    const cleanedContent = content
      .replace(/<p><br><\/p>/g, '<p></p>')
      .replace(/<p>\s*<\/p>/g, '<p></p>')
      .replace(/(\r\n|\n|\r)/gm, '');
    
    onChange(cleanedContent);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <Typography
          pb="4px"
          fontWeight={500}
          fontSize={14}
          color={clientGrey[500]}
        >
          {label}
        </Typography>
      )}
      <ReactQuill
        theme="snow"
        value={value}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'Write something...'}
        style={{ height: '250px', marginBottom: '50px' }}
      />
      {error && (
        <Typography 
          fontWeight={500} 
          fontSize={14} 
          sx={{ color: "#fe7759 !important", marginTop: '5px' }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default RichTextEditor; 